<span
  class="tier-{{ highlightColor() }}-color highlight-beam"
  [style.color]="beamColor()"
  [style.text-shadow]="beamTextShadow()"
  >↡</span>
